import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function Policies() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-black px-4 py-6 max-w-3xl mx-auto">
      {/* Back Arrow */}
      <button className="flex items-center mb-4" onClick={() => navigate(-1)}>
        <ChevronLeft className="w-6 h-6 mr-2" />
        Back
      </button>

      <h1 className="text-2xl font-bold mb-4">Policies & Support</h1>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Privacy Policy</h2>
        <p>
          At a2xshop, we respect your privacy.<br />
          We collect limited personal information (like name, email, and shipping address) only to process your orders.<br />
          We never sell or share your data with third parties, except for trusted partners (like payment gateways and delivery services) required to complete your order.<br />
          For any privacy-related questions, contact us at support@a2xshop.com.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Terms and Conditions</h2>
        <p>
          By using a2xshop.com, you agree to:<br />
          - Provide accurate information when placing orders.<br />
          - Use our web application for lawful purposes only.<br />
          - Understand that product prices, availability, and offers may change without prior notice.<br />
          We reserve the right to cancel suspicious or fraudulent orders at our discretion.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Cancellation and Refund Policy</h2>
        <p>
          Orders can be cancelled within 24 hours of purchase by contacting our support team.<br />
          Refunds are processed within 7-10 business days, back to your original payment method.<br />
          Products once shipped cannot be cancelled.<br />
          Refunds will only be issued for defective, damaged, or incorrect items delivered.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Shipping and Delivery</h2>
        <p>
          Enjoy same-day shipping on orders confirmed before noon.<br />
          For <strong>pre-ordered products</strong>, the estimated shipping time is <strong>up to 4 weeks</strong> from the date of order.<br />
          Delivery timelines may vary based on your location and courier services.<br />
          You will receive a tracking link once your order is dispatched.<br />
          Delays caused by courier or unforeseen events are beyond our control, but we will assist you in tracking your order.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
        <p>
          We’re here to help!<br />
          📧 Email: hello@a2xshop.com<br />
          📞 Phone: +91-9892835125<br />
          Business Hours: Monday – Saturday, 10 AM – 6 PM
        </p>
      </section>
    </div>
  );
}
